import { petBusinessBase, petDashboardCommands } from '../../megha/pet-business-dashboard/pet-route.util';
import { isPetClinicStoreType } from './clinic-store-types.util';

export interface PetStoreLike {
  store_type?: string | null;
  store_code?: string | null;
  is_animal?: boolean | null;
}

/** First owned pet-care / pet-clinic store (list order from API). */
export function findPrimaryPetStore<T extends PetStoreLike>(
  stores: T[] | null | undefined
): T | null {
  if (!stores?.length) return null;
  return (
    stores.find(
      (s) =>
        isPetClinicStoreType(s.store_type, { isAnimal: s.is_animal }) &&
        String(s.store_code || '').trim()
    ) ?? null
  );
}

export { petDashboardCommands, petBusinessBase };
